// 資料來源與設計說明見 app/javascript/shared/email_typo_corrections.json——
// 前後端共用同一份資料（app/libs/email_typo_suggester.rb 是後端對應的
// Ruby 版本），避免各自維護、遲早漏改。
//
// 這個檔案只放純邏輯（沒有 jQuery/DOM 依賴），方便用 Jest 直接測試；
// 實際綁定到欄位的 DOM 操作放在 bind_email_typo_suggestion.js。用
// CommonJS（module.exports）而不是 ES module，是配合這個 repo 目前
// jest.config.js 只針對 .coffee 檔案設定 transform、沒有幫 .js 開
// babel-jest 轉譯 import/export 語法的既有限制（見 spec/javascript/
// address_field/*.test.js 全部也是走這個路徑，require CommonJS 匯出的
// 純邏輯函式）。webpack 打包時 CommonJS 跟 ES module 可以互相
// require/import，不影響瀏覽器端實際運作。
//
// 軟性建議，不是驗證——只回傳建議，不會阻止表單送出。
var corrections = require('../shared/email_typo_corrections.json')

function suggestCorrection(email) {
  if (!email || email.indexOf('@') === -1) {
    return null
  }

  var parts = email.split('@')
  var localPart = parts[0]
  var domain = parts.slice(1).join('@').toLowerCase()
  var suggestion = corrections.domain_aliases[domain]

  if (!suggestion) {
    return null
  }

  return localPart + '@' + suggestion
}

module.exports = { suggestCorrection: suggestCorrection }



// WEBPACK FOOTER //
// ./app/javascript/packs/email_typo_suggestion.js